import { render, staticRenderFns } from "./modify-infor.vue?vue&type=template&id=b34ccda0&scoped=true"
import script from "./modify-infor.vue?vue&type=script&lang=js"
export * from "./modify-infor.vue?vue&type=script&lang=js"
import style0 from "./modify-infor.vue?vue&type=style&index=0&id=b34ccda0&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b34ccda0",
  null
  
)

export default component.exports